window.quizRecommendations = [
  {
    eye_color: "blue-eyes",
    hair_color: "grey-hair",
    skin_tone: "fair",
    undertone: "cool-rosy",

    day_products: [
      "porcelain-glow",
      "porcelain",
      "terra-temptation",
      "tap-that-lilac",
      "raspberry-flirt",
      "oak"
    ],

    night_products: [
      "copper-feels",
      "pearl",
      "white-pencil",
      "second-base",
      "rose",
      "cherry-lip-tease"
    ]
  },

  {
    eye_color: "blue-eyes",
    hair_color: "grey-hair",
    skin_tone: "fair",
    undertone: "warm-golden",

    day_products: [
      "radiant-ivory",
      "porcelain",
      "terra-temptation"
    ],

    night_products: [
      "copper-feels",
      "pearl",
      "white-pencil"
    ]
  }
];